module.exports = {"id":"222644","name":"Yamil Asad","rating":"72","photo":"./data/images/photos/3/222644.png","club":{"name":"D.C. United","logo":"./data/images/clubs/D.C.United.png"},"positions":["MG","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YamilAsad0.json
// module id = 4377
// module chunks = 0